export enum SerologyTrackingAction {    
    MarkReceived = 10,
    TrackPackage = 30,
    MarkRemoteShipped = 40,
    MarkShippedBack = 60
}